import { Link, useLocation, useNavigate } from "react-router-dom";
import AtriumIcon, { IconName } from "./AtriumIcon";
import { supabaseAgency } from "@/lib/supabase";

const TABS: { id: string; label: string; icon: IconName; to: string; match: (p: string) => boolean }[] = [
  { id: "today",     label: "Today",     icon: "home", to: "/",          match: (p) => p === "/" },
  { id: "clients",   label: "Clients",   icon: "grid", to: "/clients",   match: (p) => p.startsWith("/clients") },
  { id: "pipeline",  label: "Pipeline",  icon: "pipe", to: "/pipeline",  match: (p) => p.startsWith("/pipeline") || p.startsWith("/bizdev") },
  { id: "ops",       label: "Ops",       icon: "ops",  to: "/ops",       match: (p) => p.startsWith("/ops") },
  { id: "knowledge", label: "Knowledge", icon: "book", to: "/knowledge", match: (p) => p.startsWith("/knowledge") },
];

interface Props {
  onSearch: () => void;
}

export default function AtriumTopbar({ onSearch }: Props) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  async function logout() {
    await supabaseAgency.auth.signOut();
    navigate("/login");
  }

  return (
    <div
      className="h-14 flex items-center px-5 gap-6 flex-shrink-0 border-b"
      style={{ borderColor: "var(--a-border)" }}
    >
      <Link to="/" className="flex items-center gap-2.5 a-link">
        <div
          className="w-[26px] h-[26px] rounded-[7px] flex items-center justify-center text-[12px] font-bold"
          style={{ background: "linear-gradient(135deg, #7aa2ff, #c4b5fd)", color: "#0c0d10" }}
        >
          BP
        </div>
        <div className="text-[13.5px] font-semibold tracking-[-0.01em]">Beyond Peaks</div>
        <div className="text-[11px] ml-0.5" style={{ color: "var(--a-faint)" }}>OS</div>
      </Link>

      <div className="flex gap-0.5 ml-4">
        {TABS.map((t) => {
          const active = t.match(pathname);
          return (
            <Link
              key={t.id}
              to={t.to}
              className="flex items-center gap-[7px] px-[11px] py-[7px] rounded-lg text-[13px] border"
              style={{
                background: active ? "var(--a-panel)" : "transparent",
                borderColor: active ? "var(--a-border)" : "transparent",
                color: active ? "var(--a-text)" : "var(--a-muted)",
              }}
            >
              <AtriumIcon name={t.icon} size={13} />
              {t.label}
            </Link>
          );
        })}
      </div>

      <div className="ml-auto flex items-center gap-3">
        <button
          onClick={onSearch}
          className="flex items-center gap-2 px-2.5 py-[5px] rounded-lg text-[12px] min-w-[240px] border"
          style={{ borderColor: "var(--a-border)", color: "var(--a-muted)", background: "transparent" }}
        >
          <AtriumIcon name="search" size={12} />
          <span>Search vault, clients, runs…</span>
          <span className="ml-auto text-[11px]" style={{ color: "var(--a-faint)" }}>⌘K</span>
        </button>
        <button
          onClick={logout}
          className="text-[11px]"
          style={{ color: "var(--a-muted)" }}
          title="Sign out"
        >
          Sign out
        </button>
        <div
          className="w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-semibold border"
          style={{ background: "var(--a-panel)", borderColor: "var(--a-border)" }}
        >
          MX
        </div>
      </div>
    </div>
  );
}
